import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { westBabylonConfig } from "./data";

export default function WestBabylonPage() {
  return <CityPageTemplate config={westBabylonConfig} />;
}